module.exports = __webpack_public_path__ + "img/suo.44cd006.png";